<template>
  <footer
    class="pb-6"
    :class="[
      absolute ? 'absolute w-full bottom-0 bg-blueGray-800' : 'relative'
    ]"
  >
    <div class="container mx-auto px-4">
      <hr class="mb-6 border-b-1 border-blueGray-600" />
      <div class="flex items-center justify-center">
        <div class="text-sm text-blueGray-500 font-semibold py-1 text-center">
          Copyright © {{ date }}
          <a
            href="https://www.abiinteriors.com.au/"
            class="text-white hover:text-blueGray-300 text-sm font-semibold py-1"
          >
            ABI
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear()
    };
  },
  props: {
    absolute: {
      type: Boolean,
      default: false
    }
  }
};
</script>
